import { BedDouble, Clock, Minus, Sun } from "lucide-react";
import React from "react";
import { FaFacebookF, FaInstagram } from "react-icons/fa";
import { FiYoutube } from "react-icons/fi";
import { Helmet } from 'react-helmet';



const Special= () => {
     let data =[
      {id:1,
          name:"10% Exclusive Savings on V Hotel Properties",
          details:"Enjoy flat 10% savings on stays at all V Hotel properties, including The Grand Shoba and more across India.",
          icon :<BedDouble/>
      },
       {id:2,
          name:"One Card, Nationwide Privileges",
          details:"V Hotel is a premium hospitality brand, and your membership card unlocks exclusive benefits at any V Hotel property across India wherever you travel, your perks follow",
          icon :<Sun/>
      }
      , {id:3,
          name:"Early Check-In & Late Check-Out",
          details:"Enjoy added flexibility to suit your travel plans.",
          icon :<Clock/>
      }
  
     ]
  return (

<>

<Helmet>
        <title>Exclusive Member Benefits at V Hotel The Grand Shoba</title>
        <meta
          name="description"
          content="Explore the exclusive benefits for V Hotel's members, including discounts, early check-ins, and nationwide privileges at V Hotel The Grand Shoba."
        />
        <meta name="keywords" content="V Hotel Member Benefits, Exclusive Discounts, Loyalty Program, Early Check-in, Late Check-out" />
        <link rel="canonical" href="https://www.vhotelthegrandshoba.com/corporate" />
      </Helmet>


    <div className=" py-5 text-center">
      <h3 className="fw-bold mb-5">
        <span className=" corpo-special-member py-2">
        <Minus />SPECIAL MEMBER BENEFITS<Minus />
        </span>
      </h3>

      <div className="container">
     <div className="row text-center">
  {
    data?.map((item, index) => (
      <div className="col-md-4 mb-4" key={index}>
        <div className="parent">
          <div className="card">
            <div className="logo">
              <span className="circle circle1"></span>
              <span className="circle circle2"></span>
              <span className="circle circle3"></span>
              <span className="circle circle4"></span>
              <span className="circle circle5">
                {item.icon}
              </span>
            </div>
            <div className="glass"></div>
            <div className="content">
              <span className="title">{item?.name}</span>
              <span className="text">
                {item.details}
              </span>
            </div>
            <div className="bottom">
              <div className="social-buttons-container">
                <button onClick={() => window.open("https://www.instagram.com/vhotelthegrandshoba?igsh=MTZjc3Bxb25ndWFqcw==")} className="social-button social-button1">
                  <FaInstagram />
                </button>
                <button onClick={() => window.open("https://www.facebook.com/share/16TjybHqCL/")} className="social-button social-button2">
                  <FaFacebookF />
                </button>
                 <button onClick={() => window.open("https://youtu.be/UixEVGN09YU?si=uM5cpIVgYo9F1OlX")} className="social-button social-button3">
                  <FiYoutube />
                </button>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    ))
  }


          {/* <div className="col-md-4 mb-4">
          <Sun className="mb-2" style={{color:"#856a2b"}}  />
            <p className="mb-0 fw-medium">One Card, Nationwide Privileges</p>
            <p className="text-muted small">
            V Hotel is a premium hospitality brand, and your membership card unlocks exclusive benefits at any V Hotel property across India—wherever you travel, your perks follow
            </p>
          </div> */}

          {/* <div className="col-md-4 mb-4">
            <Clock className="mb-2" style={{color:"#856a2b"}} />
            <p className="mb-0 fw-medium">Early Check-In & Late Check-Out</p>
            <p className="text-muted small"> Enjoy added flexibility to suit your travel plans.
              </p>
            </div> */}
        </div>
      </div>
    </div>
</>
  );
};

export default Special;
